import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import Text from '../atoms/Text'
import Bullets from '../atoms/Bullets'
import Link from '../molecules/Link'
import Quote from '../molecules/Quote'
import Hero from '../organisms/Hero'
import Demographics from '../organisms/Demographics'
import TechUse from '../organisms/TechUse'
import Cards from '../organisms/Cards'
import PerfVsPotComparison from '../organisms/PerfVsPotComparison'
import Challenges from '../organisms/Challenges'
import Constraints from '../organisms/Constraints'
import CanvaImage from '../organisms/CanvaImage'
import Opportunities from '../organisms/Opportunities'

const Container = styled.div`
  padding: 0 1rem;
`
const Main = () => {
  //const $ = window.WILDLABS_VARS
  const [text, setText] = useState(null)
  const [notes, setNotes] = useState(null)
  const [links, setLinks] = useState(null)
  const [quotes, setQuotes] = useState(null)
  const [canvaExists, setCanvaExists] = useState(false)

  const canvaSrc = process.env.PUBLIC_URL + '/images/barriers_to_access.png'

  useEffect(() => {
    let mounted = true

    // probe the Canva image to avoid rendering a broken image
    const img = new Image()
    img.onload = () => mounted && setCanvaExists(true)
    img.onerror = () => mounted && setCanvaExists(false)
    img.src = canvaSrc

    // load CSV data used across the page
    Promise.all([
      csv(process.env.PUBLIC_URL + '/data/text.csv'),
      csv(process.env.PUBLIC_URL + '/data/chartNotes.csv'),
      csv(process.env.PUBLIC_URL + '/data/links.csv'),
      csv(process.env.PUBLIC_URL + '/data/quotes.csv')
    ]).then((data) => {
      if (!mounted) return
      setText(data[0][0])
      setNotes(data[1][0])
      setLinks(data[2])
      setQuotes(data[3])
    })

    return () => {
      mounted = false
    }
  }, [canvaSrc])

  return (
    <>
      <Hero text={text?.intro_one} />
      <Container>
        <Text text={text?.intro_two} />
        <Text text={text?.about} />
        <Link link={links ? links[0] : null} />
        <Text text={text?.what} />
        <Link link={links ? links[1] : null} />
        <Text text={text?.who_one} />
        <Demographics note={notes?.dem_note} />
        <Text text={text?.who_two} />
        <Quote quote={quotes ? quotes[0] : null} />
        <Text text={text?.current_tools_one} />
        <TechUse note={notes?.tech_use_note} />
        <Text text={text?.current_tools_two} />
        <Quote quote={quotes ? quotes[1] : null} />
        <Text text={text?.sw_one} />
        <Cards note={notes?.sw_note} />
        <Text text={text?.sw_two} />
        <Quote quote={quotes ? quotes[2] : null} />
        <Text text={text?.sw_three} />
        <Quote quote={quotes ? quotes[3] : null} />
        <Text text={text?.sw_four} />
        <Text text={text?.perf_one} />
        <Quote quote={quotes ? quotes[4] : null} />
        <Text text={text?.perf_two} />
        <PerfVsPotComparison note={notes?.perf_note} />
        <Text text={text?.perf_three} />
        <Quote quote={quotes ? quotes[5] : null} />
        <Text text={text?.constraints_one} top={true} />
        <Challenges />
        <Text text={text?.constraints_two} />
        <Quote quote={quotes ? quotes[6] : null} />
        <Text text={text?.constraints_three} />
        <Quote quote={quotes ? quotes[7] : null} />
        <Constraints note={notes?.constraints_note} />
        <Text text={text?.constraints_four} />
        <Quote quote={quotes ? quotes[8] : null} />
        <Text text={text?.constraints_five} />
        {canvaExists && (
          <CanvaImage
            src={process.env.PUBLIC_URL + '/images/barriers_to_access.png'}
            note={notes?.regression_note}
          />
        )}
        <Link link={links ? links[2] : null} />
        <Text text={text?.opp_one} />
        <Quote quote={quotes ? quotes[9] : null} />
        <Opportunities note={notes?.opp_note} />
        <Text text={text?.opp_two} />
        <Quote quote={quotes ? quotes[10] : null} />
        <Text text={text?.opp_three} />
        <Text text={text?.next_one} />
        <Quote quote={quotes ? quotes[11] : null} />
        <Text text={text?.next_two} />
        <Bullets text={text?.next_bullets} />
        <Text text={text?.next_three} />
        <Quote quote={quotes ? quotes[12] : null} />
        <Text text={text?.wl_one} />
        <Quote quote={quotes ? quotes[13] : null} />
        <Text text={text?.wl_two} />
        <Text text={text?.acknowledgments} />
      </Container>
    </>
  )
}

export default Main
